import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Table from "components/Admin/PickupLocations/Cities/Cities";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getCities,
  deleteCity,
  createCity,
  updateCity,
  changeStatusCity,
} from "store/actions/locationCities";

const Cities = () => {
  const citiesData = useSelector((state) => state.locations.cities);
  const allStates = useSelector((state) => state.locations.allStates);
  const dispatch = useDispatch();
  const [page, setPage] = useState(citiesData ? citiesData.pag.page : 1);
  const [amount, setAmount] = useState(citiesData ? citiesData.pag.amount : 10);
  const [orderField, setOrderField] = useState(
    citiesData ? citiesData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    citiesData ? citiesData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    citiesData ? citiesData.pag.search_by : "name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getCities(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  const deleteHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(deleteCity(id, pag, history));
  };
  const createHandler = (newData) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(createCity(newData, pag, history));
  };
  const updateHandler = (newData) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(updateCity(newData, pag, history));
  };
  const changeStatusHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(changeStatusState(id, pag, history));
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Cities Table</h4>
        </CardHeader>
        <CardBody>
          {citiesData && (
            <Table
              rows={citiesData.data}
              totalRows={citiesData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              //
              createHandler={createHandler}
              updateHandler={updateHandler}
              deleteHandler={deleteHandler}
              states={allStates}
              changeStatusHandler={changeStatusHandler}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Cities;
